import moment from 'moment';

export const validateBirthDay = (birthday) => {
  const birthDate = moment(birthday, 'DD/MM/YYYY', true);
  if (!birthDate.isValid()) {
    return false;
  }

  const adulthoodDate = birthDate.clone().add(18, 'years');
  const isAdult = adulthoodDate.isSameOrBefore(moment(), 'day');

  return isAdult;
};